import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "40",
  viewBox: "0 0 32 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.7143 0C11.5481 0.00491496 7.55399 1.6621 4.60805 4.60804C1.66212 7.55397 0.00493168 11.5481 1.67184e-05 15.7143C-0.00497313 19.1189 1.10713 22.4311 3.16573 25.1429C3.16573 25.1429 3.5943 25.7071 3.6643 25.7886L15.7143 40L27.77 25.7814C27.8329 25.7057 28.2629 25.1429 28.2629 25.1429L28.2643 25.1386C30.3219 22.428 31.4335 19.1173 31.4286 15.7143C31.4237 11.5481 29.7665 7.55397 26.8206 4.60804C23.8746 1.6621 19.8805 0.00491496 15.7143 0V0ZM20.8572 22.8571L15.7143 19.5843L10.5714 22.8571L11.4286 17.0371L7.14287 13.1043L13.1429 12.38L15.7143 7.14286L18.4457 12.3814L24.2857 13.1043L20 17.0371L20.8572 22.8571Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}